//http://bl.ocks.org/nbremer/21746a9668ffdf6d8242 (взят за базу для разработки)

import {colores_google, wrapText} from '@/utils/d3Utils'
import * as d3 from 'd3'

export default function RadarChart(datasets, options) {
  const cfg = {
    w: 600,				//Width of the circle
    h: 600,				//Height of the circle
    margin: {top: 20, right: 20, bottom: 20, left: 20}, //The margins of the SVG
    levels: 1,				//How many levels or inner circles should there be drawn
    maxValue: 0, 			//What is the value that the biggest circle will represent
    labelFactor: 1.19, 	//How much farther than the radius of the outer circle should the labels be placed
    wrapWidth: 60, 		//The number of pixels after which a label needs to be given a new line
    opacityArea: 0.35, 	//The opacity of the area of the blob
    dotRadius: 4, 			//The size of the colored circles of each blog
    opacityCircles: 0.1, 	//The opacity of the circles of each blob
    strokeWidth: 2, 		//The width of the stroke around each blob
    roundStrokes: false,	//If true the area and stroke will follow a round path (cardinal-closed)
    //Смещение подписей осей
    offsetXLabelText: 0,
    offsetYLabelText: -15,
    //Смещение основных подписей
    offsetXMainText: 15,
    offsetYMainText: 15,
    color: colores_google
  };

  copyOptions(options);

  function copyOptions(options) {
    if ('undefined' !== typeof options)
      for (let i in options) if (options.hasOwnProperty(i) && 'undefined' !== typeof options[i])
        cfg[i] = options[i];
  }

  if (!cfg.axis) {
    const axisNames = [...(new Set([].concat.apply([], datasets.map(data => data.map(({axis}) => axis)))))];
    cfg.axis = {};
    axisNames.forEach(name => cfg.axis[name] = {})
  }


  for (let i = 0; i < datasets.length; i++)
    for (let j = 0; j < datasets[i].length; j++)
      datasets[i][j].id = i;

  if (cfg.autoAxisMaxValue) {
    const axisMaxValues = new Map();
    const axisMargin = cfg.axisMargin || 20;
    datasets.forEach(data => {
      if (data)
        data.forEach(datasetItem => {
            if (!(axisMaxValues.has(datasetItem.axis) && axisMaxValues.get(datasetItem.axis) > datasetItem.value))
              axisMaxValues.set(datasetItem.axis, datasetItem.value);
          }
        )
    });

    for (let [axisName, maxValue] of axisMaxValues)
      if (cfg.axis[axisName])
        cfg.axis[axisName].maxValue = maxValue * (1 + axisMargin / 100);
  }


  const total = Object.keys(cfg.axis).length;
  const radius = Math.min(cfg.w / 2, cfg.h / 2); 	//Radius of the outermost circle
  const angleSlice = Math.PI * 2 / total;		//The width in radians of each "slice"

  //Копируем настройки в отдельный объект
  const axisMap = Object.assign({}, cfg.axis);

  //Добавляем в axisMap объект scale
  let count = 0;
  for (let axisID in axisMap) {
    if (!axisMap.hasOwnProperty(axisID)) continue;
    axisMap[axisID].rScale = d3.scaleLinear().range([0, radius]).domain([0, axisMap[axisID].maxValue]);
    axisMap[axisID].count = count++;
  }

  //Перечень осей
  const allAxis = Object.keys(axisMap);

  function centerTranslate(element, width, height, margin) {
    return element.append("g")
      .attr("transform", "translate(" + (width / 2 + margin.left) + "," + (height / 2 + margin.top) + ")");
  }

  function createSvgElementWithMargin(container, width, height, margin, cssClass) {
    d3.select(container).select("*").remove();

    const svg = d3.select(container).append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom);

    if (cssClass) svg.attr("class", cssClass);

    svg.append("g")
      .attr("transform", "translate(" + (width / 2 + margin.left) + "," + (height / 2 + margin.top) + ")");

    return svg;
  }

  const g = centerTranslate(createSvgElementWithMargin(cfg.container, cfg.w, cfg.h, cfg.margin, "radar"), cfg.w, cfg.h, cfg.margin);

  /////////////////////////////////////////////////////////
  /////////////// Draw the Circular grid //////////////////
  /////////////////////////////////////////////////////////

  //Wrapper for the grid & axes
  const axisGrid = g.append("g").attr("class", "axisWrapper");

  //Draw the background circles
  axisGrid.selectAll(".gridCircle")
    .data(d3.range(1, (cfg.levels + 1)).reverse())
    .enter()
    .append("circle")
    .attr("class", "gridCircle")
    .attr("r", (d) => radius / cfg.levels * d)
    .style("fill", "#b9c7d1")
    .style("fill-opacity", cfg.opacityCircles);

  /////////////////////////////////////////////////////////
  //////////////////// Draw the axes //////////////////////
  /////////////////////////////////////////////////////////

  //Create the straight lines radiating outward from the center
  const axis = axisGrid.selectAll(".axis")
    .data(allAxis)
    .enter()
    .append("g")
    .attr("class", "axis");

  //Append the lines
  axis.append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", (d) => axisMap[d].rScale(axisMap[d].maxValue * 1.03) * Math.cos(angleSlice * axisMap[d].count - Math.PI / 2))
    .attr("y2", (d) => axisMap[d].rScale(axisMap[d].maxValue * 1.03) * Math.sin(angleSlice * axisMap[d].count - Math.PI / 2))
    .attr("class", "line")
    .style("stroke", "grey")
    .style("opacity", "0.5")
    .style("stroke-width", "0.5px");

  //Append the labels at each axis
  axis.append("text")
    .attr("class", "legend")
    .style("text-align", "left")
    .style("font-size", "11px")
    .style("opacity", "0.8")
    .attr("text-anchor", "middle")
    .attr("dy", "0.35em")
    .attr("x", (d) => axisMap[d].rScale(axisMap[d].maxValue * cfg.labelFactor) * Math.cos(angleSlice * axisMap[d].count - Math.PI / 2) + cfg.offsetXLabelText)
    .attr("y", (d) => axisMap[d].rScale(axisMap[d].maxValue * cfg.labelFactor) * Math.sin(angleSlice * axisMap[d].count - Math.PI / 2) + cfg.offsetYLabelText)
    .text(d => d + (axisMap[d].postfixLabel !== undefined ? axisMap[d].postfixLabel : ''))
    .call(wrapText, cfg.wrapWidth);

  /////////////////////////////////////////////////////////
  ///////////// Draw the radar chart blobs ////////////////
  /////////////////////////////////////////////////////////

  //The radial line function
  const radarLine = d3.radialLine()
    .curve(d3.curveLinearClosed)
    .radius(d => axisMap[d.axis].rScale(d.value !== undefined ? d.value : 0))
    .angle((d) => axisMap[d.axis].count * angleSlice);

  if (cfg.roundStrokes) {
    radarLine.curve(d3.curveCardinalClosed);
  }

  //Create a wrapper for the blobs
  const blobWrapper = g.selectAll(".radarWrapper")
    .data(datasets)
    .enter().append("g")
    .attr("class", "radarWrapper");

  //Append the backgrounds
  blobWrapper
    .append("path")
    .attr("class", "radarArea")
    .attr("d", (d) => radarLine(allAxis.map(axis => {
      let val = d.find(e => e.axis === axis);
      return {axis: axis, value: val ? val.value : undefined}
    })))
    .style("fill", (d, i) => d.color || cfg.color(i))
    .style("fill-opacity", cfg.opacityArea)
    .on('mouseover', function () {
      //Dim all blobs
      d3.selectAll(".radarArea")
        .transition().duration(200)
        .style("fill-opacity", 0.1);
      //Bring back the hovered over blob
      d3.select(this)
        .transition().duration(200)
        .style("fill-opacity", 0.7);
    })
    .on('mouseout', () => {
      //Bring back all blobs
      d3.selectAll(".radarArea")
        .transition().duration(200)
        .style("fill-opacity", cfg.opacityArea);
    });

  //Create the outlines
  blobWrapper.append("path")
    .attr("class", "radarStroke")
    .attr("d", (d) => radarLine(allAxis.map(axis => {
      let val = d.find(e => e.axis === axis);
      return {axis: axis, value: val !== undefined ? val.value : undefined}
    })))
    .style("stroke-width", cfg.strokeWidth + "px")
    .style("stroke", (d, i) => {
      return d.color || cfg.color(i);
    })
    .style("fill", "none");

  //Append the circles
  blobWrapper.selectAll(".radarCircle")
    .data((d) => d.filter((e) => axisMap[e.axis] !== undefined))
    .enter().append("circle")
    .attr("class", "radarCircle")
    .attr("r", cfg.dotRadius)
    .attr("cx", (d) => axisMap[d.axis].rScale(d.value) * Math.cos(angleSlice * axisMap[d.axis].count - Math.PI / 2))
    .attr("cy", (d) => axisMap[d.axis].rScale(d.value) * Math.sin(angleSlice * axisMap[d.axis].count - Math.PI / 2))
    .style("fill", (d) => {
      console.log(d);
      return d.color || cfg.color(d.id);
    })
  .style("fill-opacity", 0.8);

  /////////////////////////////////////////////////////////
  //////// Append invisible circles for tooltip ///////////
  /////////////////////////////////////////////////////////

  //Wrapper for the invisible circles on top
  const blobCircleWrapper = g.selectAll(".radarCircleWrapper")
    .data(datasets)
    .enter().append("g")
    .attr("class", "radarCircleWrapper");

  //Статическое отображение значения по оси
  blobCircleWrapper.selectAll(".labelInvisibleCircle")
    .data((d) => d.filter((e) => axisMap[e.axis] !== undefined))
    .enter().append("text")
    .attr("class", "labelInvisibleCircle")
    .style("font-size", "13px")
    .style("font-weight", "bold")
    .attr("text-anchor", "middle")
    .text(d => d.value !== undefined ? d.value : '')
    .style('fill', "#475059")
    .attr("x", (d) => (axisMap[d.axis].rScale(d.value) + cfg.offsetXMainText) * Math.cos(angleSlice * axisMap[d.axis].count - Math.PI / 2))
    .attr("y", (d) => (axisMap[d.axis].rScale(d.value) + cfg.offsetYMainText) * Math.sin(angleSlice * axisMap[d.axis].count - Math.PI / 2))
}
